// UserStates action 
  export const UserStates = () => {
    return {
      type: 'SIGN_IN'
    }
  }